import React, { useEffect, useContext } from "react";
import { LanguageContext } from "../../contexts/LanguageContext";  // Importer le contexte

import img from "../../assets/image1.svg"; // Image principale
import javaIcon from "../../assets/skills/java.svg";
import nodejsIcon from "../../assets/skills/nodejs.webp";
import jsIcon from "../../assets/skills/Unofficial_JavaScript_logo_2.svg";
import cssIcon from "../../assets/skills/CSS3_logo.svg";
import angularIcon from "../../assets/png/angular.png";
import gitIcon from "../../assets/skills/git.svg";
import mongodbIcon from "../../assets/skills/mongodb.svg";
import tailwindIcon from "../../assets/skills/tailwind.svg";
import phpIcon from "../../assets/skills/php.png";
import cppIcon from "../../assets/skills/c-.png";
import pythonIcon from "../../assets/skills/python.png";
import laravelIcon from "../../assets/skills/laravel.svg";
import reactIcon from "../../assets/skills/react.svg";
import mysqlIcon from "../../assets/skills/mysql.svg";
import oracleIcon from "../../assets/skills/oracle.svg";
import cIcon from "../../assets/skills/c.svg";
import csharpIcon from "../../assets/skills/csharp.svg";
import githubIcon from "../../assets/skills/github.svg";
import vscodeIcon from "../../assets/skills/vscode.svg";
import intellijIcon from "../../assets/skills/intelijj.svg";
import postamnIcon from "../../assets/skills/postman.svg";
import figmaIcon from "../../assets/skills/figma.svg";
import springIcon from "../../assets/skills/spring.svg";
import meriseIcon from "../../assets/skills/mcd.svg";
import umlIcon from "../../assets/skills/uml.svg";
import androidIcon from "../../assets/png/android (2).svg";
import flutterIcon from "../../assets/png/flutter_logo.svg";
import dockerImg from "../../assets/png/docker.svg";
import jenkinsImg from "../../assets/png/jenkins.svg";
import kubernetesIcon from "../../assets/png/kubernetes.png";


import linuxImg from "../../assets/png/linux.svg";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import "./Skills.css";

// Définir les catégories et compétences avec des traductions
const skillsCategories = [
  {
    category: { en: "Web Development", fr: "Développement Web" },
    skills: [
      { name: { en: "JavaScript", fr: "JavaScript" }, icon: jsIcon },
      { name: { en: "Angular", fr: "Angular" }, icon: angularIcon },
      { name: { en: "ReactJs", fr: "ReactJs" }, icon: reactIcon },
      { name: { en: "PHP", fr: "PHP" }, icon: phpIcon },
      { name: { en: "Laravel", fr: "Laravel" }, icon: laravelIcon },
      { name: { en: "SpringBoot", fr: "SpringBoot" }, icon: springIcon },
      { name: { en: "NodeJS", fr: "NodeJS" }, icon: nodejsIcon },
    ],
  },
  {
    category: { en: "Mobile Development", fr: "Développement Mobile" },
    skills: [
      { name: { en: "Android", fr: "Android" }, icon: androidIcon },
      { name: { en: "Flutter", fr: "Flutter" }, icon: flutterIcon },
    ],
  },
  {
    category: { en: "Programming Languages", fr: "Langages de Programmation" },
    skills: [
      { name: { en: "C", fr: "C" }, icon: cIcon },
      { name: { en: "C++", fr: "C++" }, icon: cppIcon },
      { name: { en: "C#", fr: "C#" }, icon: csharpIcon },
      { name: { en: "Java", fr: "Java" }, icon: javaIcon },
      { name: { en: "Python", fr: "Python" }, icon: pythonIcon },
    ],
  },
  {
    category: { en: "Tools & Platforms", fr: "Outils et Plateformes" },
    skills: [
      { name: { en: "Git", fr: "Git" }, icon: gitIcon },
      { name: { en: "GitHub", fr: "GitHub" }, icon: githubIcon },
      { name: { en: "Docker", fr: "Docker" }, icon: dockerImg },
      { name: { en: "Kubernetes", fr: "Kubernetes" }, icon: kubernetesIcon },
      { name: { en: "Jenkins", fr: "Jenkins" }, icon: jenkinsImg },
      { name: { en: "Linux", fr: "Linux" }, icon: linuxImg },
      { name: { en: "Postman", fr: "Postman" }, icon: postamnIcon },
      { name: { en: "VsCode", fr: "VsCode" }, icon: vscodeIcon },
      { name: { en: "Intellij", fr: "Intellij" }, icon: intellijIcon },
      { name: { en: "Figma", fr: "Figma" }, icon: figmaIcon },
    ],
  },
  {
    category: { en: "Databases", fr: "Bases de Données" },
    skills: [
      { name: { en: "MongoDB", fr: "MongoDB" }, icon: mongodbIcon },
      { name: { en: "MySQL", fr: "MySQL" }, icon: mysqlIcon },
      { name: { en: "Oracle", fr: "Oracle" }, icon: oracleIcon },
    ],
  },
  {
    category: { en: "Conception", fr: "Conception" },
    skills: [
      { name: { en: "Merise", fr: "Merise" }, icon: meriseIcon },
      { name: { en: "UML", fr: "UML" }, icon: umlIcon },
    ],
  },
];

export default function SkillsSection() {
  const { language } = useContext(LanguageContext); // Récupérer la langue actuelle du contexte

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
  
    const categories = document.querySelectorAll(".skills-category");
  
    categories.forEach((category) => {
      gsap.fromTo(
        category.querySelectorAll(".animation"),
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          stagger: 0.2,
          scrollTrigger: {
            trigger: category,
            start: "top 80%",
            toggleActions: "play none none none"
          },
        }
      );
    });
  
    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);
  
  

  return (
    <section id="skills" className="skills-section">
      <h1 className="skills-title">{language === "en" ? "Skills" : "Compétences"}</h1> {/* Titre dynamique */}
      <div className="skills-container">
        {skillsCategories.map((categoryData, index) => (
          <div key={index} className={"skills-category"}>
            <h3 className="category-title animation">{categoryData.category[language]}</h3> {/* Titre dynamique des catégories */}
            <div className="skills-list">
              {categoryData.skills.map(({ name, icon }, skillIndex) => (
                <div key={skillIndex} className="skill-item animated-border animation">
                  <img
                    src={icon}
                    alt={`${name[language]} icon`}
                    width={80}
                    height={80}
                    className="skill-icon"
                  />
                  <p className="skill-name">{name[language]}</p> {/* Nom de la compétence dynamique */}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
